/**
 * Visualizations App Mutation Types
 */

/* Charts mutation types */
const ADD_CHART = 'ADD_CHART';
const REMOVE_CHART = 'REMOVE_CHART';
const UPDATE_CHART = 'UPDATE_CHART';
const INSERT_TRACE = 'INSERT_TRACE';
const UPDATE_CHARTS = 'UPDATE_CHARTS';
const UPDATE_CHART_QUERY = 'UPDATE_CHART_QUERY';
const SELECT_CHART_AREA = 'SELECT_CHART_AREA';
const SET_CURRENT_TAB = 'SET_CURRENT_TRACE';
const SET_HAS_DATA = 'SET_HAS_DATA';
const CHANGE_PLOT_TAB = 'CHANGE_PLOT_TAB';
const SET_TITLE = 'SET_TITLE';
const SET_NEXT_POSITION = 'SET_NEXT_POSITION';

/* Traces mutation types */
const ADD_TRACE = 'ADD_TRACE';
const REMOVE_TRACE = 'REMOVE_TRACE';
const UPDATE_TRACE = 'UPDATE_TRACE';
const ADD_INSTRUMENT = 'ADD_INSTRUMENT';
const REMOVE_INSTRUMENT = 'REMOVE_INSTRUMENT';
const UPDATE_TAB_INDEX = 'UPDATE_TAB_INDEX';
const UPDATE_SELECTED_AXES = 'UPDATE_SELECTED_AXES';
const UPDATE_DATETIME = 'UPDATE_DATETIME';
const UPDATE_ATTRIBUTE = 'UPDATE_ATTRIBUTE';
const RESET_TRACE = 'RESET_TRACE';

// Sidebar filters
const FILTER_AREA_SELECTION = 'FILTER_AREA_SELECTION';
const FILTER_SITE_SELECTION = 'FILTER_SITE_SELECTION';
const FILTER_INFRA_SELECTION = 'FILTER_INFRA_SELECTION';
const FILTER_INST_SELECTION = 'FILTER_INST_SELECTION';

// Data Viz updates
const UPDATE_DATA_POINT_COUNT = 'UPDATE_DATA_POINT_COUNT';

export default {
  // Charts
  ADD_CHART,
  REMOVE_CHART,
  UPDATE_CHART,
  INSERT_TRACE,
  UPDATE_CHARTS,
  SELECT_CHART_AREA,
  UPDATE_CHART_QUERY,
  SET_CURRENT_TAB,
  SET_HAS_DATA,
  CHANGE_PLOT_TAB,
  SET_TITLE,
  SET_NEXT_POSITION,
  // Trace
  ADD_TRACE,
  REMOVE_TRACE,
  UPDATE_TRACE,
  FILTER_AREA_SELECTION,
  FILTER_SITE_SELECTION,
  FILTER_INFRA_SELECTION,
  FILTER_INST_SELECTION,
  UPDATE_DATA_POINT_COUNT,
  ADD_INSTRUMENT,
  REMOVE_INSTRUMENT,
  UPDATE_TAB_INDEX,
  UPDATE_SELECTED_AXES,
  UPDATE_DATETIME,
  UPDATE_ATTRIBUTE,
  RESET_TRACE,
};
